var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M36.61,36H26.53l-0.02-0.11c-1.34-6.98-1.34-14.14,0-21.12l0.02-0.11h10.08c5.8,0,10.5,4.73,10.5,10.56v0.21 C47.11,31.27,42.41,36,36.61,36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.2,25.94l6.85-1.98c0.7-0.2,0.94-0.83,0.87-1.36c-0.08-0.55-0.5-1.1-1.17-1.1c-0.12,0-0.24,0.02-0.36,0.05 l-6.39,1.85c-0.11-0.37-0.25-0.73-0.43-1.1c-0.04-0.09-0.08-0.17-0.12-0.26l7.61-2.2c0.7-0.2,0.94-0.83,0.87-1.36 c-0.08-0.55-0.5-1.1-1.17-1.1c-0.12,0-0.24,0.02-0.36,0.05l-7.62,2.2c0-0.05-0.01-0.1-0.01-0.15v-3.92c0-1.2-1.87-1.2-1.87,0v3.8 c0,0.28,0.01,0.55,0.03,0.81l-8.34,2.41c-0.7,0.2-0.94,0.83-0.87,1.36c0.08,0.55,0.5,1.1,1.17,1.1h0c0.12,0,0.24-0.02,0.36-0.05 l8.33-2.41c0.06,0.11,0.12,0.23,0.18,0.34c0.14,0.24,0.26,0.47,0.36,0.72c0.04,0.09,0.06,0.18,0.09,0.28L2.56,26.7 c-0.7,0.2-0.94,0.83-0.87,1.36c0.08,0.55,0.5,1.1,1.17,1.1h0c0.12,0,0.24-0.02,0.36-0.05l8.94-2.58c-0.14,0.48-0.33,0.93-0.53,1.4 c-0.04,0.1-0.09,0.21-0.13,0.31l-8.95,2.58c-0.7,0.2-0.94,0.83-0.87,1.36c0.08,0.55,0.5,1.1,1.17,1.1h0c0.12,0,0.24-0.02,0.36-0.05 l7.64-2.21v3.69c0,0.6,0.48,0.92,0.94,0.92c0.45,0,0.94-0.32,0.94-0.92v-3.76c0-0.17,0.02-0.33,0.04-0.49l8.26-2.39 c0.7-0.2,0.94-0.83,0.87-1.36c-0.08-0.55-0.5-1.1-1.17-1.1c-0.12,0-0.24,0.02-0.36,0.05l-6.65,1.92c0.18-0.47,0.35-0.96,0.45-1.48 C14.19,26.06,14.19,26,14.2,25.94z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.7ce8b85c1ea79579d3c84b72e453b406.svg";
export { ForwardRef as ReactComponent };